import {
    IPriorDto,
    PriorDto,
    StatusType,
    WorklistItemDataSourceType,
    WorklistItemDetailsDto
} from '../../api-module/control-centre-api-client';
import { DetailsConstants } from './constants';
import { DetailsComponent } from './details.component';

export class EditablePriorDto extends PriorDto {
    constructor(isEditing: boolean, isNew: boolean, data?: IPriorDto) {
        super(data);
        this.isEditing = isEditing;
        this.isNew = isNew;
    }
    isEditing: boolean;
    isNew: boolean;
}
export type OrderLockedIcon = 'locking-full-lock';

export class OrderLockStatus {
    Icon: OrderLockedIcon;
    Tooltip: string;

    public static fromWorklistItem(item: WorklistItemDetailsDto): OrderLockStatus {
        const editable = DetailsComponent.isWorklistItemEditable(item);
        const uploadAllowed = DetailsComponent.isWorklistItemAllowedToUpload(item);
        let icon: OrderLockedIcon;
        let tooltip: string = null;
        if (editable) {
            // unlocked, no tooltip
            icon = null;
            tooltip = null;
        } else if (uploadAllowed) {
            // partial editing / upload allowed
            // will always be assigned
            icon = 'locking-full-lock';
            tooltip =
                item?.status === StatusType.Reported && item?.hasActiveAddenda
                    ? DetailsConstants.LOCK_TOOLTIP_PARTIAL_REPORT_ADDENDA
                    : DetailsConstants.LOCK_TOOLTIP_PARTIAL_ON_HOLD;
        } else {
            icon = 'locking-full-lock';
            if (item?.dataSource === WorklistItemDataSourceType.UnlinkedOrder) {
                tooltip = DetailsConstants.LOCK_TOOLTIP_FULL_UNLINKED;
            } else if (item?.status === StatusType.Reported) {
                tooltip = DetailsConstants.LOCK_TOOLTIP_FULL_REPORTED;
            } else {
                // assigned, no more specific full lock reason
                tooltip = DetailsConstants.LOCK_TOOLIP_FULL_ASSIGNED;
            }
        }

        return { Icon: icon, Tooltip: tooltip };
    }
}
